import * as Yup from 'yup';

export default Yup.object({
  password: Yup.string().required('Please enter a password'),
});
